import { render, staticRenderFns } from "./ranking-question.vue?vue&type=template&id=ee5683c8&"
import script from "./ranking-question.vue?vue&type=script&lang=js&"
export * from "./ranking-question.vue?vue&type=script&lang=js&"
import style0 from "./ranking-question.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports